<template>
  <b-row>
    <!-- Segmentacao -->
    <b-col cols="12">
      <h3 class="mt-3 title-3">Segmentação</h3>
      <b-row class="d-flex align-items-center">
        <b-col class="col-12 col-md-4 col-lg-3 col-xl-2">
          <b-button class="mt-2" variant="primary" @click="abrirModal"
            >Adicionar</b-button
          >
        </b-col>
      </b-row>

      <modal-segmentacao
        ref="modalSegmentacao"
        :segmentacoes="form.segmentacoes"
        :exibir="exibirModal"
        :anoLetivoId="id"
        :editarSegmentacao="editarSegmentacao"
        :avaliacaoFinal="form.avaliacaoFinal"
        @fechar="exibirModal = false"
        @atualizar="$emit('atualizar')"
      />

      <tabela-segmentacao
        :items="form.segmentacoes"
        @excluir="excluir"
        @editar="abrirModalEditar"
      />
    </b-col>
  </b-row>
</template>

<script>
import TabelaSegmentacao from './TabelaSegmentacao.vue';
import SegmentacaoService from '@/common/services/anoLetivo/segmentacao.service';
import ModalSegmentacao from './ModalSegmentacao.vue';

import { Segmentacao } from '@/common/models';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

export default {
  components: {
    TabelaSegmentacao,
    ModalSegmentacao,
  },
  props: {
    form: { type: Object, default: Object },
  },
  data() {
    return {
      formSegmentacao: new Segmentacao({}),
      id: this.$route.params.id,
      loadingStatusAbertura: false,
      exibirModal: false,
      editarSegmentacao: null,
    };
  },
  methods: {
    removerBack(id) {
      this.$store.dispatch(START_LOADING);
      SegmentacaoService.remover(id)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Segmentação excluída com sucesso')
          );
          this.$emit('atualizar');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    excluir(item) {
      mensagem
        .confirmacao(null, this.$t('Deseja remover segmentação ?'))
        .then(async (result) => {
          if (result.value) {
            if (this.id) {
              this.removerBack(item.item.id);
              return;
            }
            this.form.segmentacoes.splice(item.index, 1);
          }
        });
    },

    abrirModal() {
      this.editarSegmentacao = null;
      this.exibirModal = true;
    },
    abrirModalEditar(form) {
      this.editarSegmentacao = JSON.parse(JSON.stringify(form));
      this.exibirModal = true;
    },
  },
};
</script>

<style>
.title-3 {
  font-size: 22px;
}
.alinharValidacao {
  align-self: start;
}
</style>
